<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col :span="24">
        <container align="center">
          <btn
            @click="bottomNavigation = !bottomNavigation"
            icon-left="page-layout-footer"
            color="white"
            :color-lightness="null"
            :bg-color="$root.colors.primary"
            :bg-color-lightness="$root.colors.bgColorLightness">{{ $lang.toggleComponent(bottomNavigation, 'Bottom Navigation') }}</btn>
        </container>
      </flex-col>
    </flex>
    <transition name="fade">
      <bottom-navigation
        @input="log('input', 'bottom-navigation', $event)"
        color="white"
        v-model="selected"
        :z-index="950"
        :class="[bottomNavigation ? null : 'invisible']"
        :bg-color="$root.colors.primary"
        :bg-color-lightness="$root.colors.bgColorLightness"
        :color-lightness="null"
        :app="true"
        :items="bottomNavigationItems" />
    </transition>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageBottomNavigation',
  mixins: [
    methods
  ],
  data () {
    return {
      selected: 0,
      bottomNavigation: false,
      bottomNavigationItems: []
    }
  },
  watch: {
    bottomNavigation () {
      const navbar = this.$root.navbar
      if (!navbar.collapsed && !navbar.floating) {
        navbar.collapsed = true
        this.$nextTick(() => {
          navbar.collapsed = false
        })
      }
    }
  },
  mounted () {
    this.getExternalData('bottom-navigation.json', 'bottomNavigationItems')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/bottom-navigation.vue